<template>
  <div>

    <div class="sub-nav">
      <span class="sub-nav-icon">
        <i class="cubeic-back" @click="goBack"></i>
      </span>
      <span class="sub-nav-title">我的问答</span>
      <span class="sub-nav-right">发起新问题</span>
    </div>

    <div class="container">
      <div class="law-list">
        <div class="item title">
          <span class="name">问题类别</span>
          <span class="desc">问题描述</span>
          <span class="over">结果</span>
        </div>
        <div class="item">
          <span class="name">植物识别</span>
          <span class="desc">图像识别请求</span>
          <span class="over green">苹果</span>
        </div>
        <div class="item">
          <span class="name">咨询</span>
          <span class="desc">橘子怎么剥皮</span>
          <span class="over origin">待解答</span>
        </div>
        <div class="item">
          <span class="name">咨询</span>
          <span class="desc">橘子怎么吃</span>
          <span class="over green">已经回复</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: "online-my",

    data() {
      return {
      }
    },

    methods: {
      goBack() {
        window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
      }
    },

  }
</script>

<style lang="scss" scoped>
  @import "../assets/css/base.scss";
  .container {
    padding: 15px;
    background-color: #fff;
  }
  .law-list {
    border: 1px solid #ddd;
  }
  .law-list .item {
    display: flex;
    align-content: space-between;
    width: 100%;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
  }
  .law-list .item:last-child {
    border-bottom: 0;
  }
  .law-list .item span {
    color: #333;
    font-size: 14px;
    border-right: 1px solid #ddd;
  }
  .law-list .item span:last-child {
    border-right: 0;
  }
  .law-list .item span.name, .law-list .item span.over {
    width: 80px;
    text-align: center;
  }
  .law-list .item span.desc {
    flex: 1;
    padding: 0 10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    word-break: break-all;
  }
  .law-list .title span {
    text-align: center;
    color: #333;
    font-weight: 600;
  }
  .law-list .item span.green {
    color: #39BF3E;
  }
  .law-list .item span.origin {
    color: #ff7b19;
  }
</style>



// WEBPACK FOOTER //
// src/components/online-my.vue